import type { OpenAiAdsContext } from '@/shared/lib/openAiAdsContext';

import { BASE_URL } from './constants';
import { put } from './requestMethods';
import { sendAdsActivity } from './sendAdsActivity';

const URL = `${BASE_URL}/api/user/openai-ads`;

type OpenAiAdsActivity = {
  contents?: { id: string; content_type: 'product' | 'project'; quantity?: number }[];
  context: OpenAiAdsContext;
  event_id: string;
  event_name: 'checkout_started' | 'contents_viewed';
  price_id?: string;
  quantity?: number;
};

export const OPENAI_ADS_API = {
  sendActivity: (data: OpenAiAdsActivity) => sendAdsActivity(`${URL}/activity`, data),
  saveContext: (data: OpenAiAdsContext, signal?: AbortSignal) => put<void>(URL, { data, signal }),
};
